import Translate from '../../../src/core/Translate';

export const _CHART_COLOR = [
	// 최근 10분 CPU 사용
	"#4caf50",
	"#2196f3",
	"#f9ce1d",

	// 최근 5분 수집 추이
	"#4dd0e1",

	// 최근 10분 테이블 입력
	"#ff6737",

	// 최근 10분 테이블 입력 용량
	"orange",

	// 자바 힙
	"#4caf50",

	// 인덱스 캐시 블럭 수
	"#cddc39",

	// 인덱스 캐시 용량
	"#00e676",

	// 디스크 사용량
	"#4dd0e1",
	"#ff6737",

	// GC 소요시간
	"#1578a3",

	// GC 소요시간 분포
	"#673ab7"
]

export const CHART_COLOR = [
	"rgba(128,165,124,1)",
	"rgba(127,147,179,1)",
	"rgba(238,207,123,1)",
	"rgba(148,200,208,1)",
	"rgba(215,130,101,1)",
	"rgba(232,173,102,1)",
	"rgba(128,165,124,1)",
	"rgba(212,215,136,1)",
	"rgba(133,219,155,1)",
	"rgba(148,200,208,1)",
	"rgba(215,130,101,1)",
	"rgba(88,116,135,1)",
	"#673ab7"
];

export const ROW_LAYOUT = {
	"w": 100,
	"rows": [{
		"h": 26,
		"cols": [{
			"w": 15,
			"guid": "wdlogcollectspeed"
		}, {
			"w": 35,
			"guid": "wbd544fd6cee09922"
		}, {
			"w": 25,
			"guid": "wc1a95e7990d8e42f"
		}, {
			"w": 25,
			"guid": "wbc7c0c159b834501"
		}]
	}, {
		"h": 26,
		"cols": [{
			"w": 15,
			"guid": "threadcount"
		}, {
			"w": 35,
			"guid": "w502880d4b2add278"
		}, {
			"w": 16,
			"guid": "w50182d4f2a44ec66"
		}, {
			"w": 17,
			"guid": "w79d7e6392c915a22"
		}, {
			"w": 17,
			"guid": "w075e047fef2d1c4d"
		}]
	}, {
		"h": 30,
		"cols": [{
			"w": 25,
			"guid": "w8f69ac62a71ed46e"
		}, {
			"w": 25,
			"guid": "w76aa1fc75c7dbf39"
		}, {
			"w": 16,
			"guid": "w37d6b2b4b1c53078"
		}, {
			"w": 34,
			"guid": "wc74e2af153e3c9fc"
		}]
	}, {
		"h": 18,
		"cols": [{
			"w": 50,
			"guid": "w6013cf06360fde68"
		}, {
			"w": 50,
			"guid": "w4c8bb9c245d9da04"
		}]
	}]
}

export const setRemoteQuery = (query, node) => {
	if(node != Translate.get('$S_str_Local')) {
		return `remote ${node} [${query}]`;
	} else {
		return query;
	}
}

export const getWidgets = (node) => {
	return [
		{
			"data": {
				"query": setRemoteQuery('table limit=1 sys_logger_trends | eval rate = round(delta * 1000 / interval) | fields rate', node),
				"prefix": "",
				"column": "rate",
				"label": Translate.get("$S_ttl_SpeedOfCollect"),
				"suffix": Translate.get("$S_str_SpeedOfCollect"),
				"display_column": "rate",
				"default_color": "#ffffff",
				"type": "field",
				"formatting": ",",
				"rules": [{
					"boundary": 0,
					"color": "#ffffff",
					"operator": ">"
				}]
			},
			"columns": [{
				"type": "number",
				"key": "rate"
			}],
			"guid": "wdlogcollectspeed",
			"type": "alertbox",
			"interval": 5,
			"name": Translate.get("$S_ttl_SpeedOfCollect")
		},

		{
			"guid": "w502880d4b2add278",
			"interval": 5,
			"name": Translate.get("$S_ttl_RecentCpuUsage10minPer5sec"),
			"data": {
				"series": [{
					"color": CHART_COLOR[0],
					"name": "kernel",
					"key": "kernel"
				}, {
					"color": CHART_COLOR[2],
					"name": "user",
					"key": "user"
				}],
				"yAxisMax": 100,
				"query": setRemoteQuery('table duration=10m sys_cpu_logs | eval total = kernel + user | sort _time', node),
				"labelType": "datetime",
				"label": "_time",
				"type": "stackedArea"
			},
			"type": "chart"
		},

		{
			"data": {
				"series": [{
					"color": CHART_COLOR[3],
					"key": "speed",
					"name": "speed"
				}],
				"label": "_time",
				"type": "area",
				"query": setRemoteQuery('table duration=5m sys_logger_trends | eval speed = delta * 1000 / interval | fields _time, speed | sort _time', node),
				"labelType": "datetime",
				"hiddenOptions":{
					"enableLineAtTheBottom": true
				}
			},
			"guid": "wbd544fd6cee09922",
			"type": "chart",
			"interval": "5",
			"name": Translate.get("$S_ttl_RecentCollectTrend5min")
		},

		{
			"data": {
				"series": [{
					"color": CHART_COLOR[4],
					"key": "count",
					"name": Translate.get("$S_str_Count")
				}],
				"label": "table",
				"type": "bar",
				"query": setRemoteQuery('table duration=10m sys_table_trends | stats sum(count) as count by table | sort limit=10 -count', node),
				"labelType": "string"
			},
			"guid": "wc1a95e7990d8e42f",
			"type": "chart",
			"interval": "5",
			"name": Translate.get("$S_ttl_RecentTableInput10min")
		},

		{
			"data": {
				"series": [{
					"color": CHART_COLOR[5],
					"key": "volume",
					"name": Translate.get("$S_str_OriginalVolume")
				}],
				"label": "table",
				"type": "bar",
				"query": setRemoteQuery('table duration=10m sys_table_trends | stats sum(volume) as volume by table | sort limit=10 -volume', node),
				"labelType": "string"
			},
			"guid": "wbc7c0c159b834501",
			"type": "chart",
			"interval": "5",
			"name": Translate.get("$S_ttl_RecentTableInputVolume10min")
		},

		{
			"data": {
				"series": [{
					"color": CHART_COLOR[6],
					"key": "value",
					"name": "value"
				}],
				"label": "category",
				"type": "bar",
				"query": setRemoteQuery('table limit=1 sys_mem_logs | eval rows = array(array("' + Translate.get("$S_str_HeapMax") + '", heap_max), array("' + Translate.get("$S_str_HeapTotal") + '", heap_total), array("' + Translate.get("$S_str_HeapUsed") + '", heap_used)) | explode rows | eval category = valueof(rows, 0) | eval value = valueof(rows, 1) | fields category, value', node),
				"labelType": "string"
			},
			"guid": "w50182d4f2a44ec66",
			"type": "chart",
			"interval": "5",
			"name": Translate.get("$S_ttl_JavaHeap")
		},

		{
		"data": {
			"series": [{
				"color": CHART_COLOR[7],
				"key": "value",
				"name": "value"
			}],
			"label": "category",
			"type": "bar",
			"query": setRemoteQuery('table limit=1 sys_mem_logs | eval rows = array(array("' + Translate.get("$S_str_Table") + '", tb_count), array("' + Translate.get("$S_str_BloomFilter0") + '", bf0_count), array("' + Translate.get("$S_str_BloomFilter1") + '", bf1_count), array("' + Translate.get("$S_str_InversedIndex") + '", iv_count)) | explode rows | eval category = valueof(rows, 0) | eval value = valueof(rows, 1) | fields category, value', node),
			"labelType": "string"
		},
		"guid": "w79d7e6392c915a22",
		"type": "chart",
		"interval": "5",
		"name": Translate.get("$S_ttl_CacheBlockCount")
		},

		{
			"data": {
				"series": [{
					"color": CHART_COLOR[8],
					"key": "value",
					"name": "value"
				}],
				"label": "category",
				"type": "bar",
				"query": setRemoteQuery('table limit=1 sys_mem_logs | eval rows = array(array("' + Translate.get("$S_str_Tablecache") + '", tb_weight), array("' + Translate.get("$S_str_BloomFilter0Cache") + '", bf0_weight), array("' + Translate.get("$S_str_BloomFilter1Cache") + '", bf1_weight), array("' + Translate.get("$S_str_InversedIndexCache") + '", iv_weight)) | explode rows | eval category = valueof(rows, 0) | eval value = valueof(rows, 1) | fields category, value', node),
				"labelType": "string"
			},
			"guid": "w075e047fef2d1c4d",
			"type": "chart",
			"interval": "5",
			"name": Translate.get("$S_ttl_CacheVolume")
		},

		{
			"data": {
				"order": ["name", "idle", "log_count"],
				"query": setRemoteQuery('proc sys_idle_loggers()', node)
			},
			"guid": "w6013cf06360fde68",
			"type": "grid",
			"interval": "5",
			"name": Translate.get("$S_ttl_IdleLoggerMonitor")
		},

		{
			"data": {
				"order": ["host_name", "os", "is_connected", "last_connect_at"],
				"query": setRemoteQuery('sentry | fields host_name, os, is_connected, last_connect_at', node)
			},
			"guid": "w4c8bb9c245d9da04",
			"type": "grid",
			"interval": "5",
			"name": Translate.get("$S_ttl_SentryLoggerMonitor")
		},

		{
			"data": {
				"series": [{
					"color": CHART_COLOR[10],
					"key": "used",
					"name": "used"
				}, {
					"color": CHART_COLOR[9],
					"key": "free",
					"name": "free"
				}],
				"label": "partition",
				"type": "stackedbar",
				"query": setRemoteQuery('table duration=1d sys_disk_logs | search scope == "partition" | stats first(used) as used, first(free) as free by partition', node),
				"labelType": "string"
			},
			"guid": "w8f69ac62a71ed46e",
			"type": "chart",
			"interval": "5",
			"name": Translate.get("$S_ttl_CurrentDiskUsage")
		},

		{
			"data": {
				"autoSeries": true,
				"excludeSeries": ["_time"],
				"label": "_time",
				"type": "line",
				"query": setRemoteQuery('table duration=7d sys_disk_logs | search scope == "partition" | timechart span=1h max(total - free) by partition', node),
				"labelType": "datetime"
			},
			"guid": "w76aa1fc75c7dbf39",
			"type": "chart",
			"interval": "5",
			"name": Translate.get("$S_ttl_RecentDiskDiskUsageTrend1w")
		},

		{
			"data": {
				"series": [{
					"color": CHART_COLOR[12],
					"key": "type",
					"name": "type"
				}],
				"label": "type",
				"type": "boxplot",
				"query": setRemoteQuery('table duration=10m sys_gc_logs | boxplot duration by type', node),
				"labelType": "string",
				"appointedColumn": {
					"isEnableAppointColumn": false
				}
			},
			"guid": "w37d6b2b4b1c53078",
			"type": "chart",
			"interval": "5",
			"name": Translate.get("$S_ttl_RecentGCTimeDist10min")
		},

		{
			"data": {
				"series": [{
					"color": CHART_COLOR[11],
					"key": "duration",
					"name": "duration"
				}],
				"label": "_time",
				"type": "area",
				"query": setRemoteQuery('table duration=10m sys_gc_logs | fields - changes | sort _time', node),
				"labelType": "datetime"
			},
			"guid": "wc74e2af153e3c9fc",
			"type": "chart",
			"interval": "5",
			"name": Translate.get("$S_ttl_RecentGCTime10min")
		},

		{
			"data": {
				"series": [{
					"color": CHART_COLOR[12],
					"key": "count",
					"name": "count"
				}],
				"label": "state",
				"type": "pie",
				"displayTotal": true,
				"query": setRemoteQuery('proc sys_thread_count()', node),
				"labelType": "string"
			},
			"guid": "threadcount",
			"type": "chart",
			"interval": "5",
			"name": Translate.get("$S_ttl_ThreadCount")
		}
	];
}


// WEBPACK FOOTER //
// ./resources/WEB-INF/package/system/starter/Starter.service.js